import { Text } from '@gympass/yoga';
import { AlertCircle } from '@gympass/yoga-icons';
import { FormattedMessage } from 'react-intl';

import * as S from './styles';

const PhaseOut: React.FC = () => (
  <S.Container icon={AlertCircle} data-testid="phaseOut">
    <Text.Small>
      <FormattedMessage
        id="PSYCHOLOGICALRECORD.BANNER.RECORDSDELETION"
        values={{
          phaseOutLimitDate: '20/07/2023',
          b: (text: string) => <b>{text}</b>,
        }}
      />
    </Text.Small>
  </S.Container>
);

export default PhaseOut;
